module.exports = __webpack_public_path__ + "img/Ylands-PolyBackground-skyblue-02.c4d91777.png";